export default __webpack_public_path__ + "static/media/AES-New-Delhi.67f488db.jpg";